import { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { PhoneOff, ScanLine } from "lucide-react";

export default function VideoRoom() {
  const { room } = useParams();
  const { user } = useAuth();
  const nav = useNavigate();
  const containerRef = useRef(null);
  const apiRef = useRef(null);

  useEffect(() => {
    const load = () => {
      if (!window.JitsiMeetExternalAPI) return;
      apiRef.current = new window.JitsiMeetExternalAPI("meet.jit.si", {
        roomName: `MedHOne-${room}`,
        parentNode: containerRef.current,
        width: "100%",
        height: "100%",
        userInfo: { displayName: user?.name || "Guest" },
        configOverwrite: { prejoinPageEnabled: false, disableDeepLinking: true },
      });
    };
    if (window.JitsiMeetExternalAPI) load();
    else {
      const s = document.createElement("script");
      s.src = "https://meet.jit.si/external_api.js";
      s.async = true;
      s.onload = load;
      document.body.appendChild(s);
    }
    return () => { try { apiRef.current?.dispose(); } catch {} };
  }, [room, user?.name]);

  return (
    <div className="min-h-[calc(100vh-64px)] bg-slate-950 text-white flex flex-col">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-800">
        <div>
          <div className="text-xs uppercase tracking-widest text-teal-300">Video consultation</div>
          <div className="font-mono text-sm">Room · {room}</div>
        </div>
        <div className="flex gap-2">
          <Button data-testid="upload-rx-btn" variant="outline" onClick={() => nav("/prescription")} className="border-teal-500/50 text-teal-300">
            <ScanLine className="w-4 h-4 mr-2" /> Upload prescription
          </Button>
          <Button data-testid="leave-btn" onClick={() => nav("/patient")} className="bg-red-600 hover:bg-red-500 text-white">
            <PhoneOff className="w-4 h-4 mr-2" /> Leave
          </Button>
        </div>
      </div>
      <div ref={containerRef} className="flex-1" style={{ minHeight: 500 }} data-testid="jitsi-container" />
    </div>
  );
}
